import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Box, Button, List, ListItemText, ListItemButton, TextField, Typography } from "@mui/material";
import Footer from "../components/footer";
import Header, { AuthKey, AdminKey } from "../components/header";
import { productList } from "../components/productList";
import { wait } from '@testing-library/user-event/dist/utils';
import { priceList } from '../components/priceList';

export default function ShipIt() {
  const navigate = useNavigate();
  const adminKey = new URLSearchParams(useLocation().search)?.get('zxcv');
  const AddressVerified = 'Address Verified';
  const VerityAddressId = 'adr_e9e00fc379a111f0948eac1f6bc539aa';
  const orderId = new URLSearchParams(useLocation().search)?.get('orderId');
  const [order, setOrder] = useState({});
  const [loading, setLoading] = useState(true);

  const [addressId, setAddressId] = useState("");
  const [name, setName] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [verifiedMessage, setVerifiedMessage] = useState("");

  const [pounds, setPounds] = useState(0);
  const [ounces, setOunces] = useState(0);
  const [selectedRate, setSelectedRate] = useState(-1);
  const [shippingRates, setShippingRates] = useState([]);
  const [shipmentId, setShipmentId] = useState(0);

  useEffect(() => {
      // Check if the user is an admin
      if (adminKey !== AdminKey)
          navigate('/');

      async function getOrder() {
        // Call the lambda to get the order
        await fetch("https://7xy9woipl7.execute-api.us-west-2.amazonaws.com/prod/getOrder?orderId=" + orderId + "&marker=" + AuthKey, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: '',
        })
        .then((res) => res.json())
        .then((data) => {
          setOrder(data);
          setName(data?.customer.name);
          setAddress1(data?.customer.addressLine1);
          setAddress2(data?.customer.addressLine2);
          setCity(data?.customer.city);
          setState(data?.customer.state);
          setZipcode(data?.customer.zip);
          setLoading(false);
        });
      }
      if (loading) {
        getOrder();
        // estimateOrderWeight();
        setVerifiedMessage("Address has not been verified");
      }
  }, [order, loading, orderId, adminKey, navigate]);

  const verifyAddress = async () => {
    let body = {
      "name": name,
      "street1": address1,
      "street2": address2,
      "city": city,
      "state": state,
      "zip": zipcode,
      "country": "US",
      "verify_strict": true
    };
    try {
      await fetch("https://7xy9woipl7.execute-api.us-west-2.amazonaws.com/prod/verifyAddress?marker=" + AuthKey, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      })
      .then((res) => res.json())
      .then((data) => {
          if (data?.code != null) {
            const messages = data?.errors.map(err => err.message);
            setVerifiedMessage(messages.join(", "));
          }
          else
          {
            setAddressId(data?.id);
            setName(data?.name);
            setAddress1(data?.street1);
            setAddress2(data?.street2);
            setCity(data?.city);
            setState(data?.state);
            setZipcode(data?.zip);
            setVerifiedMessage(AddressVerified);
          }
      });
    }
    catch (err) {
      alert("An error occurred while verifying the address: " + err);
    }
  }

  const getRates = async () => {
    let body = {
      "from_address": { "id": VerityAddressId },
      "to_address": { "id": addressId },
      "parcel": { "weight": pounds * 16 + ounces }
    };
    try {
      await fetch("https://7xy9woipl7.execute-api.us-west-2.amazonaws.com/prod/getRates?marker=" + AuthKey, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      })
      .then((res) => res.json())
      .then((data) => {
        setShipmentId(data?.id);
        setShippingRates(data?.rates);
      });
    }
    catch (err) {
      alert("An error occurred while getting the shipping rates: " + err);
    }
  }

  const handleRateItemClick = (event, index) => {
    setSelectedRate(index);
  }

  const shipIt = async () => {
    try {
      // Disable the button to prevent multiple clicks
      setVerifiedMessage("Buying the order postage...");
      // Call the lambda to buy the shipment
      const rateId = shippingRates[selectedRate]?.id;
      await fetch("https://7xy9woipl7.execute-api.us-west-2.amazonaws.com/prod/shipIt?marker=" + AuthKey + '&shipmentId=' + shipmentId + '&rateId=' + rateId + '&orderId=' + orderId, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: ''
      })
      .then(
        wait(2000).then(() => {
          // After waiting 2 seconds for the shipment to finish processing, open the shipping label page
          window.open("shippinglabel?shipmentId=" + shipmentId, "_blank");
          wait(1000).then(() => {
            // Close the current window after a second
            window.close();
          });
        })
      );
    }
    catch (err) {
      alert("An error occurred while buying the shipment: " + err);
    }
  }
 
  return (adminKey === AdminKey && <HelmetProvider>
    <Helmet title={"Ship Order " + orderId}/>
    <Header />
    <Box sx={{ boxShadow: "5px 5px 10px 0px rgb(0 0 0 / 50%)", padding: "10px 16px 0px 16px", display: "flex", justifyContent: "center" }}>
      <Box sx={{ maxWidth: "1280px", width: "100%" }}>
        <h1>{"Ship Order " + orderId}</h1>
        <Box sx={{ borderRadius: "6px", backgroundColor: "white", padding: "10px", marginBottom: "50px", display: "flex", flexDirection: "column" }}>
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <TextField sx={{ margin: "5px 0", width: "250px" }} label="Name" value={name} onChange={ (e) => setName(e.target.value) } />
              <TextField sx={{ margin: "5px 0", width: "250px" }} label="Address Line 1" value={address1} onChange={ (e) => setAddress1(e.target.value) } />
              <TextField sx={{ margin: "5px 0", width: "250px" }} label="Address Line 2" value={address2} onChange={ (e) => setAddress2(e.target.value) } />
              <Box sx={{ display: "flex", flexDirection: "row" }}>
                <TextField sx={{ margin: "5px 5px 5px 0", width: "250px" }} label="City" value={city} onChange={ (e) => setCity(e.target.value) } />
                <TextField sx={{ margin: "5px 5px", width: "100px" }} label="State" value={state} onChange={ (e) => setState(e.target.value) } />
                <TextField sx={{ margin: "5px 5px", width: "150px" }} label="Zip Code" value={zipcode} onChange={ (e) => setZipcode(e.target.value) } />
              </Box>
            </Box>
            <Box sx={{ display: "flex", padding: "80px", flexDirection: "column" }}>
              <Typography sx={{marginBottom: "20px", color: verifiedMessage !== AddressVerified ? "red" : "black"}}>
                {verifiedMessage}
              </Typography>
              <Button variant="contained" onClick={verifyAddress}
                      disabled={name === "" || address1 === "" || city === "" || state === "" || zipcode === ""} >
                Verify Address
              </Button>
            </Box>
          </Box>
          <table style={{ width: '100%', borderCollapse: 'collapse', borderTop: 'black 1px solid', marginTop: '20px', paddingTop: '20px' }}>
            <tr>
              <td style={{ padding: "20px 0 0 20px", width: "10%"}}><strong>Qty</strong></td>
              <td style={{ padding: "20px 0 0 0", width: "50%"}}><strong>Item</strong></td>
              <td style={{ padding: "20px 0 0 0"}}><strong>Weight</strong></td>
              <td style={{ padding: "20px 0 0 0"}}><strong>Price</strong></td>
            </tr>
            {order?.items?.map((item, index) => {
              return (
            <tr>
              <td style={{ padding: "8px 0 0 25px"}}>{item.quantity}</td>
              <td style={{ padding: "8px 0 0 0"}}>{productList.filter(p => p.ProductID === item.productId)[0]?.Title}</td>
              <td style={{ padding: "8px 0 0 0"}}>
                {item.quantity * priceList.filter(p => p.ProductID === item.productId && (p.FormatType === 1 || p.FormatType === 2))[0]?.Weight / 16.0} lbs</td>
              <td style={{ padding: "8px 0 0 0"}}>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(item.unitPrice / 100)}</td>
            </tr>)})}
            <tr>
              <td></td>
              <td style={{ padding: "15px 0 0 0"}}><strong>Tax</strong></td>
              <td></td>
              <td style={{ padding: "15px 0 0 0"}}>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(order?.tax / 100)}</td>
            </tr>
            <tr>
              <td></td>
              <td style={{ padding: "6px 0 0 0"}}><strong>Shipping & handling</strong></td>
              <td></td>
              <td style={{ padding: "6px 0 0 0"}}>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(order?.sandh / 100)}</td>
            </tr>
            <tr>
              <td></td>
              <td style={{ padding: "12px 0 0 0"}}><strong>Total</strong></td>
              <td>{order?.items?.reduce((total, item) => { 
                return total + item.quantity * priceList.filter(p => p.ProductID === item.productId && (p.FormatType === 1 || p.FormatType === 2))[0]?.Weight / 16.0; }, 0)} lbs</td>
              <td style={{ padding: "12px 0 0 0"}}>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(order?.total / 100)}</td>
            </tr>
          </table>
          <Box sx={{ display: "flex", flexDirection: "row", borderTop: "black 1px solid", marginTop: "15px", paddingTop: "15px" }}>
            <Typography sx={{ margin: "25px 0 20px 20px"}}>Shipment weight:</Typography>
            <TextField sx={{ margin: "10px", width: "100px" }} label="Pounds" value={pounds} onChange={ (e) => setPounds(Number.isNaN(Number(e.target.value)) ? 0 : Number(e.target.value)) } />
            <TextField sx={{ margin: "10px", width: "100px" }} label="Ounces" value={ounces} onChange={ (e) => setOunces(Number.isNaN(Number(e.target.value)) ? 0 : Number(e.target.value)) } />
            <Button sx={{ margin: "20px 0 20px 50px", height: "40px", float: "right" }}
                    disabled={verifiedMessage !== AddressVerified || (ounces === 0 && pounds === 0)}
                    variant="contained" onClick={getRates}>
              Get Shipping Rates
            </Button>
          </Box>
          { shippingRates.length > 0 &&
          <Box sx={{ display: "flex", flexDirection: "row", marginTop: "15px" }}>
            <Box sx={{ bgcolor: "#f8f8f8", border: "black 1px solid", borderRadius: "4px", padding: "5px" }}>
              <List>
                {shippingRates.sort((a,b) => a.rate - b.rate).map((rate, index) => {
                  return (
                    <ListItemButton dense="true" sx={{ height: "25px" }} selected={selectedRate === index} 
                                    onClick={(event) => handleRateItemClick(event, index)}>
                      <ListItemText sx={{padding: "0 3px", width: "60px"}}>{rate.carrier === "UPSDAP" ? "UPS" : rate.carrier}</ListItemText>
                      <ListItemText sx={{padding: "0 3px", width: "150px"}}>
                        {rate.service.includes("UPSGroundsaver") ? "Ground Saver" : 
                        rate.service.includes("HOME") ? "Home Delivery" :
                        rate.service.includes("_SAVER") ? "Express Saver" :
                        rate.service.includes("2_DAY_AM") ? "2 Day AM Express" :
                        rate.service.includes("2_DAY") ? "2 Day Express" :
                        rate.service === "STANDARD_OVERNIGHT" ? "Overnight" :
                        rate.service === "PRIORITY_OVERNIGHT" ? "Priority Overnight" :
                        rate.service === "FIRST_OVERNIGHT" ? "First Overnight" : rate.service }</ListItemText>
                      <ListItemText sx={{padding: "0 3px", width: "80px"}}>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(rate.rate)}</ListItemText>
                      <ListItemText sx={{padding: "0 3px", width: "60px"}}>({rate.delivery_days} days)</ListItemText>
                      {/* <ListItemText><s>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(rate.retail_rate)}</s></ListItemText> */}
                    </ListItemButton>
                  );
                })}
              </List>
            </Box>
            <Button sx={{ margin: "50px", height: "40px", float: "right" }}
                    disabled={verifiedMessage !== AddressVerified || (ounces === 0 && pounds === 0) || selectedRate < 0}
                    variant="contained" onClick={shipIt}>
               Ship the Order
            </Button>
          </Box> }
        </Box>
      </Box>
    </Box>
    <Footer />
  </HelmetProvider>);
}